module.exports = __webpack_public_path__ + "static/media/dgl-laptop.c4bd85c2.png";